import { useState } from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { ACKNOWLEDGEMENT } from "@/lib/legal";

export default function ConsentCheckbox({ checked, onChange, testid = "terms-checkbox" }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div data-testid="terms-clickwrap" className={`rounded-xl border p-3 transition-colors ${checked ? "border-emerald-300 bg-emerald-50/40" : "border-[#F5A623] bg-[#FFF7E8]"}`}>
      <label className="flex items-start gap-3 cursor-pointer">
        <Checkbox id={testid} data-testid={testid} checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" />
        <span className="text-xs text-slate-800 leading-relaxed">
          <span className={expanded ? "" : "line-clamp-3"}>{ACKNOWLEDGEMENT}</span>
          <button type="button" data-testid="terms-expand" onClick={(e) => { e.preventDefault(); setExpanded(!expanded); }} className="text-[#0A2A5E] font-semibold hover:underline ml-1">{expanded ? "Show less" : "Read full statement"}</button>
        </span>
      </label>
      <div className="text-[11px] text-slate-600 mt-2 pl-7">
        Review the <Link to="/terms" target="_blank" data-testid="terms-link" className="text-[#0A2A5E] font-semibold hover:underline">Terms of Service</Link> and <Link to="/privacy" target="_blank" data-testid="privacy-link" className="text-[#0A2A5E] font-semibold hover:underline">Privacy Policy</Link>. Acceptance is required.
      </div>
    </div>
  );
}
